// Who can see a node. Shared by WhoCanView and the sign-off rail (NodeAdminComponent),
// where the public users who can view a node are the people expected to sign it.
// nodeLocations / nodeDepartments are the parsed LocationsJSON / DepartmentsJSON arrays.

function parseList(json: any): string[] {
    if(!json) return [];
    try {
        return JSON.parse(json) || [];
    } catch(e) {
        return [];
    }
}

export function adminUsersForNode(users: any[], nodeDepartments: string[]): any[] {
    return users.filter((user: any) => {
        if(!user.RestrictDepartments) return true;
        return parseList(user.DepartmentsJSON).some((dep: string) => nodeDepartments.includes(dep));
    });
}

export function publicUsersForNode(publicUsers: any[], nodeLocations: string[], nodeDepartments: string[]): any[] {
    return publicUsers.filter((user: any) => {
        // Inactive standard users (terminated, offboarded or awaiting approval) can't sign in, so they can't view the
        // node or be expected to sign it; this keeps them out of the sign-off counts and Who Can View
        if(user.InActive) return false;
        // primary Location or any AdditionalLocationsJSON
        const userLocations = [user.Location].concat(parseList(user.AdditionalLocationsJSON));
        if(!userLocations.some((loc: string) => nodeLocations.includes(loc))) return false;
        return parseList(user.DepartmentsJSON).some((dep: string) => nodeDepartments.includes(dep));
    });
}
